import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { applyFormat } from 'components/ui/ui-helpers';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
        fontSize:10,
    },
    description: {
        width: '55%',
        textAlign: 'left',
        // borderRightColor: borderColor,
        // borderRightWidth: 1,
        paddingLeft: 8,
    },
    qty: {
        width: '17%',
        // borderRightColor: borderColor,
        // borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    rate: {
        width: '15%',
        // borderRightColor: borderColor,
        // borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    amount: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });


const InvoiceTableRow = ({items}) => {
    const rows = items.map( (item,k) => 
        <View style={styles.row} key={k.toString()}>
            {/* <Text style={styles.description}>{item.name}</Text> */}
            <Text style={styles.description}>Licence REM'EXPERT</Text>
            <Text style={styles.qty}>{applyFormat(item.price, "ufloat", { precision:2,thousands: " ", decimal: ",", unit: " €" })} </Text>
            <Text style={styles.rate}>{item.quantity}</Text>
            <Text style={styles.amount}>{applyFormat(item.total_pre_tax_amount, "ufloat", { precision:2,thousands: " ", decimal: ",", unit: " €" })}</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
  export default InvoiceTableRow